<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>短信</li>
                <li><a href="#">通讯录</a></li>
            </ul>
        </div>
        
        <div class="formbody">
        
        
        <ul class="seachform mt20">
        
        <li><label>手机号码</label><input name="" v-model="mobile" type="text" class="scinput" /></li>
        
        <li><label>状态</label>
        <div class="cityleft">
        <!-- <select class="select3" > -->
            <el-select v-model="status" placeholder="请选择">
                <el-option label="未处理" value="0"></el-option>
                <el-option label="补发" value="1"></el-option>
                <el-option label="不补发" value="2"></el-option>
            </el-select>
        <!-- </select> -->
        </div>
        </li>
        
        <li><label>内容</label><input name="" v-model="content" type="text" class="scinput" style="width:300px;"/></li>
        
        <li><label>&nbsp;</label><input name="" type="button" class="scbtn" @click="pageChange(1)" value="查询"/></li>
        
        </ul>
        
        <div class="tools lh33">
        <b>补发请确认费用是否足够</b>
        </div>
        
            <div class="tools">
            <ul class="toolbars">
            <li @click="sendSms(1)">选择补发</li>
            <li @click="sendSms(2)">选择不补发</li>
            <!-- <li>选中项删除</li> -->
            </ul>
        
        </div>
        
        <table class="tablelist" style="table-layout: fixed;">
            <thead>
            <tr>
            <th style="width:3%;"><input name="allCheck" id="allCheck" @click="changAllCheck()" type="checkbox" value=""/> </th>
            <th class="tdof" style="width:15%;">手机号</th>
            <th style="width:40%;">短信内容</th>
            <th style="width:7%;">通道</th>
            <th style="width:15%;">发送时间</th>
            <th style="width:10%;">说明</th>
            <th style="width:10%;">操作</th>
            </tr>
            </thead>
            <tbody>
            
            <tr v-for="(item,index) in smsmtsenderrorList" :class="{odd:index%2!=0}">
                <td style="width:3%;">
                    <ol v-if="item.status==0 && item.errorMsg=='费用不足'"><input name="ids" id="ids" type="checkbox" :value="item.id" /></ol>
                </td>
                <td class="tdof" style="width:15%;" :title="item.mobile">{{item.mobile}}</td>
                <td style="width:40%;">{{item.content}}</td>
                <td style="width:7%;">{{item.channel}}</td>
                <td style="width:15%;">{{item.createtime}}</td>
                <td style="width:10%;">{{item.errorMsg}}</td>
                <td style="width:10%;">
                    <ol v-if="item.status==0 && item.errorMsg=='费用不足'"><a style="color:blue;" href="#" @click="sendOneSms(item.id,1)">补发</a>&nbsp;&nbsp;<a style="color:blue;" href="#" @click="sendOneSms(item.id,2)">不补发</a></ol>
                    <ol v-else-if="item.status==1">已处理(补发)</ol><ol v-else-if="item.status==2">已处理(不补发)</ol>
                    <ol v-else>----</ol>
                </td>
            </tr> 
            

            
        </tbody>
        </table>
        
    
        <div class="pagin">
    	    <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="[50]"
                :page-size="50"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount">
            </el-pagination>
        </div>
        
    
    <div class="jian">&nbsp;</div>
        </div> 
        
        
        <div class="tip">
            <div class="tiptop"><span>提示信息</span><a></a></div>
            
        <div class="tipinfo">
            <span><img src="images/ticon.png" /></span>
            <div class="tipright">
            <p>是否确认对信息的修改 ？</p>
            <cite>如果是请点击确定按钮 ，否则请点取消。</cite>
            </div>
            </div>
            
            <div class="tipbtn">
            <input name="" type="button"  class="sure" value="确定" />&nbsp;
            <input name="" type="button"  class="cancel" value="取消" />
            </div>
        
        </div>

        <!-- 查询等待 -->
        <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
            top: 0; left: 0;display: block;" v-show="loadingShow"></div>
        <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
            -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
            <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
            <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
        </div>

    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            mobile:'',
            status: '',
            content:'',
            pageIndex:0,
            totalCount:0,
            smsmtsenderrorList:[],
            loadingShow: true,
        }
    },
    mounted(){
        this.pageChange(1);
    },
    methods:{
        handleSizeChange(val) {
            this.pageChange(val);
        },
        handleCurrentChange(val) {
            this.pageChange(val);
        },
        pageChange(pageIndex){
            this.loadingShow = true;
            let that = this;
            let data = {'pageIndex':pageIndex,'pageSize':50,'mobile':this.mobile,'status':this.status,'content':this.content};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/smsmtsenderror.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.smsmtsenderrorList = res.data.smsmtsenderrorList;
                    that.pageIndex = parseInt(pageIndex);
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        changAllCheck(){
            var checkers = document.getElementsByName('ids');
            if (document.getElementById("allCheck").checked == true)
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = true;
                }
            }
            else
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = false;
                }
            }
        },
        sendSms(flag){
            var ids = '';
            var checkers = document.getElementsByName('ids');
            for ( var i = 0; i < checkers.length; i++){
                if(checkers[i].checked){
                    if(ids =='')
                        ids = checkers[i].value;
                    else
                        ids = ids + ',' + checkers[i].value;
                }
            }
            if(ids == ''){
                alert("请先选择要补发的项！");
                return;
            }
            let that = this;
            let data = {'id':ids,'flag':flag};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/operationsmsmtsenderror.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("操作成功！");
                    that.pageChange(1);
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        sendOneSms(id,flag){
            let that = this;
            let data = {'id':id,'flag':flag};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/operationsmsmtsenderror.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("操作成功！");
                    that.pageChange(1);
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/sms/smsmtsenderror.vue